import { Container } from '@mui/material'
import { styled } from '@mui/system'

export const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(2.5),
  textAlign: 'center',
  color: theme.palette.text.disabled
}))
